import { BackgroundCircle } from '@components/atoms/BackgroundCircle/BackgroundCircle';
import { LayoutInner, LayoutWrapper } from '@components/ions/layouts';
import { Footer, FooterProps } from '@components/molecules/Footer/Footer';
import { Header, HeaderProps } from '@components/organisms/Header/Header';
import { SkeletonHeader } from '@components/organisms/Header/Header.skeleton';

import { useResponsive } from '@utils/hooks/useResponsive';

import { LayoutContent } from './DefaultLayout.styled';

export interface DefaultLayoutProps {
    children: React.ReactNode;
    className?: string;
    contentPadding?: {
        bottom?: number;
        top?: number;
    };
    footerProps?: FooterProps;
    headerProps?: HeaderProps;
    hideBackgroundImage?: boolean;
    hideFooter?: boolean;
    isSkeleton?: boolean;
}

/**
 * Use Container (ions/layouts.ts) for content you add in the children prop
 */
export const DefaultLayout = ({
    children,
    className,
    contentPadding,
    footerProps,
    headerProps,
    hideBackgroundImage,
    hideFooter,
    isSkeleton,
}: DefaultLayoutProps) => {
    const isMd = useResponsive('md');
    const defaultContentPadding = {
        bottom: contentPadding?.bottom ?? 0,
        top: contentPadding?.top ?? 48,
    };

    return (
        <LayoutWrapper className={className}>
            {!hideBackgroundImage && !isMd && <BackgroundCircle />}
            <LayoutInner hideFooter={hideFooter}>
                {isSkeleton ? <SkeletonHeader /> : <Header {...headerProps} />}
                <LayoutContent contentPadding={defaultContentPadding}>
                    {children}
                </LayoutContent>
                {!hideFooter && <Footer {...footerProps} />}
            </LayoutInner>
        </LayoutWrapper>
    );
};
